import { FC, useState } from "react";
import styled from "styled-components";
import { AnimatePresence } from "framer-motion";

import AddButton from "@/components/AddButton";
import { SrOnly } from "@/components/Layout/Parts";
import { Table, TableContent, Th } from "@/components/Table";
import ToggableHeading from "@/components/ToggableHeading";
import { AddButtonHolder } from "./Notes";
import SceneNotesTableRow from "./SceneNotesTableRow";
import SceneNotesModal from "./SceneNotesModal";
import { ProductionSceneNoteResource } from "@/types/resources";

const StyledTable = styled(Table)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.grayscale};
  th,
  td {
    font-size: 11px;
    vertical-align: top;
    &:nth-child(1) {
      width: 50%;
      padding-left: 24px;
    }
    &:nth-child(2) {
      width: calc(50% - 56px);
    }
    &:last-child {
      width: 56px;
      position: relative;
      padding-right: 16px;
    }
  }
  td {
    font-weight: 700;
    font-size: 12px;
    line-height: 16px;
  }
`;

const TableHolder = styled.div`
  margin-bottom: 56px;
`;

interface Props {
  notes: ProductionSceneNoteResource[][];
  scenes: number[];
}

const SceneNotesTable: FC<Props> = ({ notes, scenes }) => {
  const [isOpen, setIsOpen] = useState(true);

  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <ToggableHeading
        heading="SCENE NOTES"
        onToggle={() => setIsOpen((prev) => !prev)}
        isOpen={isOpen}
      />
      {isOpen && (
        <TableHolder>
          <StyledTable $fixed>
            <thead>
              <tr>
                <Th>Title</Th>
                <Th>Notes</Th>
                <Th>
                  <SrOnly>Actions</SrOnly>
                </Th>
              </tr>
            </thead>
            <tbody>
              <TableContent
                isLoading={false}
                colSpan={3}
                isError={false}
                hasData={true}
              >
                {notes.map((sceneNotes, index) =>
                  sceneNotes.map((note) => (
                    <SceneNotesTableRow
                      key={note.id}
                      sceneIndex={index + 1}
                      note={note}
                    />
                  ))
                )}
              </TableContent>
            </tbody>
          </StyledTable>
          <AddButtonHolder>
            <AddButton onClick={() => setShowModal(true)}>
              Add scene notes
            </AddButton>
          </AddButtonHolder>
          <AnimatePresence>
            {!!showModal && (
              <SceneNotesModal
                scenes={scenes}
                onClose={() => setShowModal(false)}
              />
            )}
          </AnimatePresence>
        </TableHolder>
      )}
    </>
  );
};

export default SceneNotesTable;
